import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import IncentivesCategorized from '../components/IncentivesCategorized';
import IncentiveDetailCategorized from '../components/IncentiveDetailCategorized';
import IncentiveDetail from '../components/IncentiveDetail';
import IncentiveWrapper from '../components/IncentiveWrapper';
import IncentiveModal from '../components/IncentiveModal';
import IncentiveDock from '../components/IncentiveDock';
import '../global-sass/main.scss';
import { viewSpecialsDetailsEvent } from '../utils/analytics';
import { filterIncentives, categorizeIncentives } from '../utils/utility';

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			incentive: {},
			isModalVisible: false
		};
		this.setModalStateData = this.setModalStateData.bind(this);
	}

	setModalStateData(incentive, isModalVisible) {
		const { windowId, widgetName } = this.props.widgetInfo;
		if (incentive && Object.keys(incentive).length > 0) {
			const { title } = incentive;
			viewSpecialsDetailsEvent(widgetName, windowId, title);
		}

		this.setState({
			incentive,
			isModalVisible
		});
	}

	render() {
		let rootComponent = null;
		if (
			// eslint-disable-next-line react/prop-types
			this.props.flags['ws-detailed-incentives-filtered-and-categorized']
		) {
			const {
				incentives,
				widgetInfo,
				account,
				labels,
				prefs
			} = this.props;
			const { windowId, widgetName, deviceType } = widgetInfo;
			const isMobile = deviceType === 'MOBILE';
			const accountName = account ? account.name : null;

			if (incentives && incentives.length > 0) {
				const filteredIncentives = filterIncentives(incentives, prefs);
				const incentiveCount = filteredIncentives.length;

				if (incentiveCount) {
					// We have incentives to display

					let dialog = (
						<IncentiveModal
							incentive={this.state.incentive}
							isModalVisible={this.state.isModalVisible}
							setModalStateData={this.setModalStateData}
							windowId={windowId}
							widgetName={widgetName}
						/>
					);
					if (isMobile) {
						dialog = (
							<IncentiveDock
								incentive={this.state.incentive}
								isModalVisible={this.state.isModalVisible}
								setModalStateData={this.setModalStateData}
								windowId={windowId}
								widgetName={widgetName}
							/>
						);
					}
					if (incentiveCount === 1) {
						// Display single incentive
						rootComponent = (
							<div>
								<IncentiveDetailCategorized
									incentives={filteredIncentives}
									setModalStateData={this.setModalStateData}
									labels={labels}
									heading=""
									isMobile={isMobile}
								/>
								{dialog}
							</div>
						);
					} else if (prefs.incentiveDisplayGrouping === 'none') {
						// Display list of incentives with no headings
						rootComponent = (
							<div>
								<IncentiveWrapper
									incentiveCount={incentiveCount}
									isMobile={isMobile}
									windowId={windowId}
									widgetName={widgetName}
									labels={labels}
								>
									<IncentiveDetailCategorized
										incentives={filteredIncentives}
										setModalStateData={
											this.setModalStateData
										}
										labels={labels}
										heading=""
										isMobile={isMobile}
									/>
								</IncentiveWrapper>
								{dialog}
							</div>
						);
					} else {
						// Display grouped list of incentives, with headings
						rootComponent = (
							<div>
								<IncentiveWrapper
									incentiveCount={incentiveCount}
									isMobile={isMobile}
									windowId={windowId}
									widgetName={widgetName}
									labels={labels}
								>
									<IncentivesCategorized
										categorizedIncentives={categorizeIncentives(
											filteredIncentives
										)}
										separateConditional={
											prefs.incentiveDisplayGrouping ===
											'type-and-conditional'
										}
										setModalStateData={
											this.setModalStateData
										}
										labels={labels}
										isMobile={isMobile}
										accountName={accountName}
									/>
								</IncentiveWrapper>
								{dialog}
							</div>
						);
					}
				}
			}
			// TODO: remove this code with 'ws-detailed-incentives-filtered-and-categorized' flag
		} else {
			const { incentives, widgetInfo, labels } = this.props;
			const { windowId, widgetName, deviceType } = widgetInfo;
			const isMobile = deviceType === 'MOBILE';
			if (incentives && incentives.length > 0) {
				let dialog = (
					<IncentiveModal
						incentive={this.state.incentive}
						isModalVisible={this.state.isModalVisible}
						setModalStateData={this.setModalStateData}
						windowId={windowId}
						widgetName={widgetName}
					/>
				);
				if (isMobile) {
					dialog = (
						<IncentiveDock
							incentive={this.state.incentive}
							isModalVisible={this.state.isModalVisible}
							setModalStateData={this.setModalStateData}
							windowId={windowId}
							widgetName={widgetName}
						/>
					);
				}
				const incentiveCount = incentives.length;
				if (incentiveCount > 1) {
					rootComponent = (
						<div>
							<IncentiveWrapper
								incentiveCount={incentiveCount}
								isMobile={isMobile}
								windowId={windowId}
								widgetName={widgetName}
								labels={labels}
							>
								<IncentiveDetail
									incentives={incentives}
									setModalStateData={this.setModalStateData}
								/>
							</IncentiveWrapper>
							{dialog}
						</div>
					);
				} else {
					rootComponent = (
						<div>
							<IncentiveDetail
								incentives={incentives}
								setModalStateData={this.setModalStateData}
							/>
							{dialog}
						</div>
					);
				}
			}
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	incentives: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			disclaimer: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool
		}).isRequired
	).isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		deviceType: PropTypes.string.isRequired
	}).isRequired,
	// TODO: make required when removing 'ws-detailed-incentives-filtered-and-categorized' flag
	account: PropTypes.shape({
		name: PropTypes.string
	}),
	labels: PropTypes.shape({}).isRequired,
	prefs: PropTypes.shape({}).isRequired,
	flags: PropTypes.shape({}).isRequired
};

// TODO: delete 'account' when removing 'ws-detailed-incentives-filtered-and-categorized' flag
WidgetContainer.defaultProps = {
	account: {}
};

const mapStateToProps = state => {
	return {
		incentives: state.incentives,
		widgetInfo: state.requestData,
		account: state.account,
		labels: state.labels,
		prefs: state.prefs,
		flags: state.flags
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx